import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toggleUserActiveThunk } from "../../store/reducers/users/users.thunks";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { closeConfirmToggle } from "../../store/reducers/users/users.reducer";

const ConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleUserId, toggleNextState, toggling } =
    useSelector((state) => state.users);

  const handleConfirm = () => {
    dispatch(
      toggleUserActiveThunk({
        id: toggleUserId,
        isActive: toggleNextState,
      }),
    );
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {toggling ? (
        <Loader center text="Actualizando usuario..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{toggleNextState ? "activar" : "desactivar"}</strong> este
            usuario?
          </p>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeConfirmToggle())}
            >
              Cancelar
            </button>

            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleModal;
